import { ControlledCheckbox } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

export const IsOnlyOwnerCheckbox: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  return (
    <ControlledCheckbox
      {...props}
      name={type}
    />
  );
};
